import { t } from '@lingui/macro';
import React from 'react';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { HEX_PARKINGS_GRADIENT_LEGEND } from '../../../constants/legends';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';

const aggHexForParkingsComponent = () => (
    <LegendRenderer config={HEX_PARKINGS_GRADIENT_LEGEND} />
);

export const AggHexForParkingsFilter = withDisplayedLayersCheck(aggHexForParkingsComponent, t`Гексагоны для парковок`);
